<mat-toolbar color="custom" id="main-menu-header">
	<img src="{{logourl}}" class="logo" />
</mat-toolbar>
<div class="main-content">
	<div class="card p-3">
		<router-outlet></router-outlet>
	</div>
</div>